export const DELETE_SEPA_DD_MANDATE_AGREEMENT = gql`
    mutation DeleteSepaMandate($id: Int!) {
        deleteSepaMandate(id: $id) {
            id
            documentType
        }
    }
`;
